import { Component, OnInit, Input, inject } from '@angular/core';
import { FbService, SeoService, ShareMessagesService, UtilService, VariablesService, VwoService } from '../../../../shared/services';
import { FacebookService } from 'ngx-facebook';

@Component({
  selector: 'app-social-share-btn',
  templateUrl: './social-share-btn.component.html',
  styleUrls: ['./social-share-btn.component.scss']
})
export class SocialShareBtnComponent implements OnInit {

  private readonly seo = inject(SeoService);

  @Input() public fundraiser;
  @Input() public basicInfo;
  @Input() public isFundraiserEnded;
  @Input() public telegram;
  @Input() public dream11;
  showBtns = false;
  noClass = true;
  currency;
  isMobile;
  shareButtons = [
    { color: '#E1306C', icon: 'icon-instagram1', label: 'Instagram', medium: 'insta_share', pos: 1 },
    { color: '#13cb6a', icon: 'icon-whatsapp', label: 'Whatsapp', medium: 'whatsapp_share', pos: 1 },
    { color: '#3b5998', icon: 'icon-facebook', label: 'Facebook', medium: 'fbShare', pos: 1 },
    { color: '#FB633A', icon: 'icon-mail', label: 'Mail', medium: 'email', pos: 1 },
    { color: '#0077B5', icon: 'icon-linkedin', label: 'LinkedIn', medium: 'linkedin', pos: 1 },
    { color: '#2c99d7', icon: 'icon-twitter', label: 'Tweet', medium: 'twShare', pos: 1 },
  ];

  constructor(
    public vars: VariablesService,
    public vwo: VwoService,
    private shareMessagesService: ShareMessagesService,
    private utilService: UtilService,
    private fbService: FbService,
    public fb: FacebookService
  ) { }
  userData;

  ngOnInit() {
    this.utilService.currency.subscribe(res => {
      this.currency = res;
    });
    this.isMobile = this.utilService.isMobile();
    this.vars.userData.subscribe(val => {
      this.userData = val;
    })
    if (!this.vwo.insta_share_AB()) {
      this.shareButtons = this.shareButtons.filter(item => item.medium !== 'insta_share');
    }
  }

  shareClickListner(e) {
    this.noClass = false;
    this.showBtns = !this.showBtns;
  }

  share(btn) {
    this.shareMessagesService.shareEvents(btn.medium, btn.pos);
    switch (btn.medium) {
      case 'whatsapp_share': this.shareOnWhatsApp(); break;
      case 'fbShare': this.shareOnFb(this.geturl(btn)); break;
      case 'twShare': this.shareOnTwitter(this.geturl(btn)); break;
      case 'linkedin': this.shareOnLinked(this.geturl(btn)); break;
      case 'email': this.shareOnGmail(); break;
      case 'insta_share': this.shareOnInstagram(btn); break;
    }
  }

  shareOnInstagram(data) {
    this.shareMessagesService.instagramShare(data, this.fundraiser);
  }

  /**Get the url of for share */
  geturl(btn) {
    if (this.utilService.isBrowser && this.fundraiser) {
      const data = {
        source: 'internal',
        medium: btn.medium,
        campaign_name: this.fundraiser.custom_tag,
        term: btn?.term || ''
      };
      const page = this.vars.campaignType === 'stories' ? 'stories' : 'fundraiser';
      const link = `${this.utilService.domain_details.domain_url}/${page}/${this.fundraiser.custom_tag}`;
      return this.shareMessagesService.getLinkWithUtmTags(link, data);
    } else {
      return '';
    }
  }

  shareOnTwitter(url) {
    const size = 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0';
    const text = encodeURIComponent(this.fundraiser.title);
    window.open(`http://twitter.com/intent/tweet?url=${encodeURIComponent(url)}` + `&text=${text}`, '', size);
  }

  async shareOnWhatsApp() {
    const message = await this.shareMessagesService.getWhatsAppMessage(this.fundraiser, this.basicInfo, this.isFundraiserEnded);
    const whatsAppDomain = this.utilService.isMobile() ? 'api' : 'web';
    setTimeout(() => window.open(`https://${whatsAppDomain}.whatsapp.com/send?text=${message}`, '_blank'), 0);
  }

  async shareOnFb(url) {
    await this.fbService.scriptLoaderFB();
    const params = {
      href: `${url}`,
      method: 'share',
      message: this.fundraiser.title || ''
    };
    this.fb.ui(params);
  }

  shareOnLinked(url) {
    window.open(`http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`, 'sharer', 'toolbar=0, status=0, width=626, height=436');
  }

  async shareOnGmail() {
    const message = await this.shareMessagesService.getWhatsAppMessage(this.fundraiser, this.basicInfo, this.isFundraiserEnded, { utm_medium: 'emailShare', utm_term: 'emailShare' }, true);
    setTimeout(() => {
      window.open(`https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=Your+Subject+here&body=${message}&ui=2&tf=1&pli=1`, 'sharer', 'toolbar=0,status=0,width=648,height=395');
    }, 0);
  }

}
